// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3hxRC","colMin":"styles_colMin__1EYMd","colCheckbox":"styles_colCheckbox__3nAjM"};